import { UNIT } from '../../constants';

const styles = secondaryColor => ({
  starsIcon: {
    color: secondaryColor,
    verticalAlign: 'middle'
  },
  loyaltyButton: {
    backgroundColor: secondaryColor,
    color: 'white',
    height: '30px',
    borderRadius: UNIT
  }
});

export default styles;
